import { memo } from "react";
import classNames from "classnames";
import "./Step.scss";
import PropTypes from "prop-types";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import CircleOutlinedIcon from "app/pages/.shared/static/icons/Stepper/CircleOutlinedIcon";
import FilledCircleCheckedIcon from "app/pages/.shared/static/icons/Stepper/FilledCircleCheckedIcon";

const Step = ({ label, isCompleted = false, isCurrent = false }) => {
	const stepClassName = classNames("step", {
		"step--completed": isCompleted,
		"step--current": isCurrent,
	});

	const stepIcon = isCompleted ? (
		<FilledCircleCheckedIcon data-testid="filled-circle-checked-icon" />
	) : (
		<CircleOutlinedIcon data-testid="circle-outlined-icon" />
	);

	return (
		<li key={label} className={stepClassName} data-testid={`step-${label}`}>
			{stepIcon}
			<Typography
				className="step__label"
				isBold={isCurrent}
				variant={TYPOGRAPHY_VARIANTS.XSMALL}
				variantMD={TYPOGRAPHY_VARIANTS.SMALL}
				component="p"
			>
				{label}
			</Typography>
		</li>
	);
};

Step.propTypes = {
	label: PropTypes.string.isRequired,
	isCompleted: PropTypes.bool,
	isCurrent: PropTypes.bool,
};

export default memo(Step);
